import script from "./PortalMyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalMyPage.vue?vue&type=script&setup=true&lang=js"

export default script